import React, { Component } from 'react';
import { Empty, Spin, Table } from 'antd';
import { makeMsisdnBeautiful } from '../../Utils';
import { CAMPAIGNS_RESOURCE_NAME } from '../../config/constants';
import { _callResource } from '../../context/_callResource';
import TEXTS from '../../locale/texts';
import { contactsFromFileColumns } from './columns/contactsFromFileColumns';
import AnimateEnter from '../AnimateEnter';

class CampaignMsisdns extends Component {
  state = {
    msisdnsOfCampaignsData: null,
    msisdnsOfCampaignsDataIsLoading: false,
    pageSize: 20,
    currentPage: 1,
    isMounted: true
  };

  callResource = _callResource.bind(this);

  componentDidMount() {
    const { id, promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'getMsisdnsOf',
      apiCallParams: { id },
      promiseCancelToken
    });
  }

  onCancel = () => {
    const { hideDrawer } = this.props;
    hideDrawer();
  };

  render() {
    const { lang, isMsisdnsWithData } = this.props;
    const {
      msisdnsOfCampaignsData,
      msisdnsOfCampaignsDataIsLoading,
      pageSize, currentPage, isMounted
    } = this.state;

    const columns = isMsisdnsWithData ? contactsFromFileColumns(pageSize, currentPage, lang) : [{
      title: TEXTS.thPhoneNumber[lang],
      dataIndex: 'msisdn',
      render: (msisdn) => makeMsisdnBeautiful(msisdn)
    }];

    const msisdnsList = msisdnsOfCampaignsData
      ? msisdnsOfCampaignsData : [];

    return (
      <div>
        <h3 className="t-light mb-4">{TEXTS.msisdnList[lang]}</h3>
        {msisdnsOfCampaignsDataIsLoading
          ? <Empty description={TEXTS.dataIsLoading[lang]}>
            <div style={{ marginTop: 15, textAlign: 'center' }}>
              <Spin spinning={true}/>
            </div>
          </Empty> :
          <AnimateEnter paginationAnimate={{ isMounted }}>
            <Table
              columns={columns}
              dataSource={msisdnsList}
              pagination={{
                pageSize: pageSize,
                hideOnSinglePage: true,
                size: 'large',
                onChange: (page) => {
                  window.scrollTo(0 ,86);
                  this.setState({
                    currentPage: page,
                    isMounted: false
                  });
                  setTimeout(() => {
                    this.setState({
                      isMounted: true
                    });
                  }, 0);
                }
              }}
            />
          </AnimateEnter>
        }
      </div>
    );
  }
}

export default CampaignMsisdns;
